(() => {
  'use strict';

  const SELECTOR = '[data-pdp-installment][data-b1-installment-guard="true"]';

  const completeSetActive = (productInfo) => {
    if (!productInfo) return false;

    const frameSelected = productInfo.querySelector('[data-b1-frame-bandware-option] [data-b1-bandware-choice].is-selected');
    if (frameSelected?.dataset.b1BandwareChoice === 'add') return true;

    const linkSelected = productInfo.querySelector('[data-b1-link-bandware-option] [data-b1-link-bandware-choice].is-selected');
    if (linkSelected?.dataset.b1LinkBandwareChoice === 'complete') return true;

    const bandwareSelected = productInfo.querySelector('[data-bandware-native-pdp] [data-bandware-set-choice].is-selected');
    if (bandwareSelected?.dataset.bandwareSetChoice === 'complete') return true;

    return false;
  };

  const update = (scope = document) => {
    const roots = scope.matches?.(SELECTOR) ? [scope] : Array.from(scope.querySelectorAll?.(SELECTOR) || []);
    roots.forEach((wrapper) => {
      const productInfo = wrapper.closest('product-info');
      const hide = completeSetActive(productInfo);
      wrapper.hidden = hide;
      wrapper.setAttribute('aria-hidden', hide ? 'true' : 'false');
    });
  };

  const refreshFromEvent = (event) => {
    const productInfo = event?.target?.closest?.('product-info');
    if (productInfo) update(productInfo);
    else update(document);
  };

  document.addEventListener('b1-frame:bandware-change', refreshFromEvent);
  document.addEventListener('b1-link:bandware-change', refreshFromEvent);
  document.addEventListener('bandware:context-change', () => update(document));
  document.addEventListener('shopify:section:load', (event) => update(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => update(document), { once: true });
  } else {
    update(document);
  }
})();
